import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PushSettings = lazy(() =>
  import("@scenes/PushSettings/PushSettings").then((module) => ({
    default: module.PushSettings,
  }))
);

export const pushSettingsNRO: NavigationRoutingObject = {
  Component: PushSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("push-pill-menu-option", "Push Settings"),
  pageNameForTracking: () => "Push Settings",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("push");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("push-time-to-live", "Push Time-To-Live (TTL)")],
      description: t("previously-push-time-to-live", 'Previously "Push Time-To-Live (TTL)"'),
    },
    {
      keywords: [t("push-ttl-settings", "Push TTL Settings")],
      description: t("previously-push-ttl-settings", 'Previously "Push TTL Settings"'),
    },
    {
      keywords: [t("email-preferences-manage-settings", "Manage Settings")],
      description: t("previously-manage-settings", 'Previously in "Manage Settings"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
